import { playAudio, stopAudio } from './audio.utils';
import { countDownTimer } from './countdown-timer.utils';
import { objectToArray } from './object-to-array.utils';
import { getRamdomColor } from './random-color.utils';
import { sortValues } from './sort-values.utils';
import { xJsonPath } from './xjson-path.utils';

const utils = {
  countDownTimer,
  objectToArray,
  playAudio,
  stopAudio,
  getRamdomColor,
  sortValues,
  xJsonPath
};

export default utils;
